export class ClassroomSummaryFilter {
    AttStatusNone = true;
    AttStatusPartial = true;
    AttStatusAll = true;
    AttStatusPerfect = true;
    GradingNone = true;
    GradingPartial = true;
    GradingAll = true;
    RCGNone = true;
    RCGAll = true;
    RCGEx = true;
    Meets: string = '';
    MeetsOperation: string = '0';
    Term: string = '';
    TermOperation: string = '0';
    CourseSection: string = '';
    CourseSectionOperation: string = '0';
    Course: string = '';
    CourseOperation: string = '0';
    Room: string = '';
    RoomOperation: string = '0';
    Enrolled: string = '';
    EnrolledOperation: string = '0';
    Instructor: string = '';
    InstructorOperation: string = '0';

    get CourseName(): string {
        return this.Course;
    }
}